document.addEventListener('DOMContentLoaded', () => {
  const sectionEl = document.querySelector('.colour-room-slider-section');
  if (!sectionEl) return;

  const track = sectionEl.querySelector('.colour-room-slider__track');
  const handle = sectionEl.querySelector('.colour-room-slider__handle');
  const stopEls = [...sectionEl.querySelectorAll('.colour-room-stop')];

  if (!track || !handle || !stopEls.length) return;

  const stops = stopEls.map((el) => {
    const colours = [el.dataset.colour];
    const labels = [el.dataset.label];
    let i = 2;
    while (el.dataset[`colour${i}`] && el.dataset[`label${i}`]) {
      colours.push(el.dataset[`colour${i}`]);
      labels.push(el.dataset[`label${i}`]);
      i++;
    }
    return {
      pct: Number(el.dataset.pct),
      colour: el.dataset.colour,
      colours,
      label: el.dataset.label,
      labels,
      key: el.dataset.key,
    };
  });

  let activeIndex = 0;

  const setHandlePos = (pct) => handle.style.setProperty('--handle-left', pct + '%');

  const nearestStopIndex = (clientX) => {
    const rect = track.getBoundingClientRect();
    const pct = Math.max(0, Math.min(100, ((clientX - rect.left) / rect.width) * 100));
    let nearest = 0;
    let minDist = Infinity;
    stops.forEach(({ pct: sPct }, i) => {
      const dist = Math.abs(sPct - pct);
      if (dist < minDist) { minDist = dist; nearest = i; }
    });
    return nearest;
  };

  const restartPulse = () => {
    handle.classList.remove('is-pulsing');
    void handle.offsetWidth;
    handle.classList.add('is-pulsing');
  };

  const selectIndex = (idx) => {
    const stop = stops[idx];
    if (!stop) return;
    activeIndex = idx;
    setHandlePos(stop.pct);
    handle.setAttribute('aria-valuenow', idx);
    document.dispatchEvent(new CustomEvent('colour-room:colour-selected', {
      detail: {
        colourKey: stop.key,
        colourHex: stop.colour,
        label: stop.label,
        colours: stop.colours,
        labels: stop.labels,
      },
    }));
  };

  const restoreIndex = (idx) => {
    const stop = stops[idx];
    if (!stop) return;
    activeIndex = idx;
    setHandlePos(stop.pct);
    handle.setAttribute('aria-valuenow', idx);
  };

  // drag
  let dragging = false;

  const snapToNearest = (clientX) => selectIndex(nearestStopIndex(clientX));

  const onMove = (clientX) => {
    const rect = track.getBoundingClientRect();
    const pct = Math.max(0, Math.min(100, ((clientX - rect.left) / rect.width) * 100));
    setHandlePos(pct);
  };

  const onEnd = (clientX) => {
    if (!dragging) return;
    dragging = false;
    handle.classList.remove('is-dragging');
    snapToNearest(clientX);
    document.removeEventListener('mousemove', onMouseMove);
    document.removeEventListener('mouseup', onMouseUp);
  };

  const onMouseMove = (e) => onMove(e.clientX);
  const onMouseUp = (e) => onEnd(e.clientX);

  handle.addEventListener('mousedown', (e) => {
    e.preventDefault();
    restartPulse();
    dragging = true;
    handle.classList.add('is-dragging');
    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
  });

  handle.addEventListener('touchstart', (e) => {
    e.preventDefault();
    restartPulse();
    dragging = true;
    handle.classList.add('is-dragging');

    const onTouchMove = (ev) => { ev.preventDefault(); onMove(ev.touches[0].clientX); };
    const onTouchEnd = (ev) => {
      if (!dragging) return;
      dragging = false;
      handle.classList.remove('is-dragging');
      snapToNearest(ev.changedTouches[0].clientX);
      document.removeEventListener('touchmove', onTouchMove);
      document.removeEventListener('touchend', onTouchEnd);
    };

    document.addEventListener('touchmove', onTouchMove, { passive: false });
    document.addEventListener('touchend', onTouchEnd);
  }, { passive: false });

  track.addEventListener('pointerdown', (e) => {
    if (handle.contains(e.target)) return;
    restartPulse();
  });

  track.addEventListener('click', (e) => {
    if (handle.contains(e.target)) return;
    snapToNearest(e.clientX);
  });

  handle.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
      e.preventDefault();
      selectIndex(Math.min(activeIndex + 1, stops.length - 1));
    } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
      e.preventDefault();
      selectIndex(Math.max(activeIndex - 1, 0));
    }
  });

  // restore from URL
  const urlParams = new URL(window.location.href).searchParams;
  const savedLabels = urlParams.getAll('filter.v.option.color');
  const savedIdx = savedLabels.length > 0
    ? stops.findIndex((s) => {
        if (s.labels.length !== savedLabels.length) return false;
        return s.labels.every((l) => savedLabels.some((sl) => sl.toLowerCase() === l.toLowerCase()));
      })
    : -1;

  if (savedIdx !== -1) {
    const gridEl = document.querySelector('[data-crg-section-id]');
    const serverFiltered = gridEl?.dataset.crgServerFiltered === 'true';
    if (serverFiltered) {
      restoreIndex(savedIdx);
    } else {
      setTimeout(() => selectIndex(savedIdx), 0);
    }
  } else {
    setTimeout(() => selectIndex(0), 0);
  }
});
